module.exports = __webpack_public_path__ + "static/media/bank3.0cdfc90f.png";